import React from 'react';
import styles from './SmartOffer.module.css';
import useEsiPortal from '../../hooks/useEsiPortal';

function SmartOffer() {
  const ref = useEsiPortal('esi-smart-offer');

  return <div ref={ref} data-testid="smart-offer" className={styles.container} />;
}

export default SmartOffer;
